<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <div class="flex flex-col justify-between gap-5 md:flex-row">
        <div class="relative flex items-center self-start">
            <button
                class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
                (click)="goback()">
                <mat-icon
                    class="w-[5px] h-[3px] mr-[1px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                    svgIcon="icons:arrow-icon">
                </mat-icon>
            </button>
            <h1 class="text-black title-6 md:title-3">Mantención de folios</h1>
        </div>
        <div class="">
            <div class="flex justify-between gap-3 pr-10 md:px-5">
                <div>
                    <p class="font-light title-11">Folios disponibles</p>
                    <p class="title-6">{{ foliosDisponibles }}</p>
                </div>
                <div class="">
                    <p class="font-light title-11">Próximo folio</p>
                    <p class="title-6">{{ proximoFolio }}</p>
                </div>
            </div>
            <button mat-flat-button color="primary" class="w-full my-5 md:w-auto" (click)="modalFolios = true">Ingresar nuevo rango de folios</button>
        </div>
    </div>

    <app-mat-custom-table
        (action)="onTableAction($event)"
        [use_selection]="true"
        [use_detail]="true"
        [selection]="selection"
        [dataset]="dataSource"
        [columns]="columns">
    </app-mat-custom-table>

    <div class="flex flex-col gap-20 pt-5 md:items-center md:flex-row">
        <div class="flex flex-col gap-1">
            <p class="text-sm font-light">Cantidad de rangos</p>
            <span class="title-6">{{ selection.selected.length }}</span>
        </div>
        <button
            [disabled]="selection.selected.length === 0"
            mat-flat-button
            color="primary"
            class="w-full mt-5 transition-all duration-300 ease-in-out md:w-auto"
            (click)="modalEliminar = true">
            Eliminar
        </button>
    </div>
</main>

<!-- Modal Folios -->
<div *ngIf="modalFolios" class="fixed inset-0 grid w-full h-full px-8 bg-opacity-50 bg-primary-black-01 z-999 place-items-center">
    <article class="w-full max-w-[481px] bg-primary-white-01 rounded-2xl px-10 py-8 md:px-16 md:pt-14 md:pb-10 relative">
        <button
            class="absolute top-3 right-3 md:right-8 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="handleModalFoliosClose()">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <fuse-alert
            *ngIf="showAlert"
            class="my-2"
            [name]="'alertCrear'"
            [appearance]="'soft'"
            [dismissible]="true"
            [showIcon]="false"
            [type]="alert.type"
            [@shake]="alert.type === 'error'">
            {{ alert.message }}
        </fuse-alert>
        <h1 class="mt-5 text-xl font-bold text-center md:text-[28px] title-5">Ingresar rango de folios</h1>
        <form class="mt-5">
            <mat-form-field hideRequiredMarker class="w-full">
                <mat-label>Folio inicial</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    placeholder="1"
                    #folioinicial="ngModel"
                    maxlength="20"
                    [patterns]="customPatterns"
                    [dropSpecialCharacters]="false"
                    mask="0*"
                    [(ngModel)]="folioInicial"
                    [ngModelOptions]="{ standalone: true }"
                    class="h-[26px]" />
            </mat-form-field>
            <mat-form-field hideRequiredMarker class="w-full">
                <mat-label>Folio final</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    maxlength="20"
                    placeholder="100"
                    class="h-[26px]"
                    #foliofinal="ngModel"
                    [patterns]="customPatterns"
                    [dropSpecialCharacters]="false"
                    mask="0*"
                    [(ngModel)]="folioFinal"
                    [ngModelOptions]="{ standalone: true }" />
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Fecha ingreso</mat-label>
                <input matInput [matDatepicker]="datepicker" [formControl]="date" class="py-[18px] title-9 font-semibold" />
                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>Cancelar</button>
                        <button mat-raised-button color="primary" matDatepickerApply>Aplicar</button>
                    </mat-datepicker-actions>
                </mat-datepicker>
            </mat-form-field>
            <button
                mat-flat-button
                class="flex items-center justify-center w-48 h-10 mx-auto mt-5 btn-md btn-primary"
                [color]="'primary'"
                [disabled]="!folioinicial.valid || !foliofinal.valid"
                (click)="guardarNuevoFolio()">
                <span>Guardar Cambios</span>
                <!-- <mat-progress-spinner *ngIf="loginForm.disabled" [diameter]="24" [mode]="'indeterminate'">
					</mat-progress-spinner> -->
            </button>
        </form>
        <p *ngIf="showGuardar" class="text-center text-primary-blue-01 paragraph-5 mt-7">Registro guardado exitosamente.</p>
    </article>
</div>

<!-- Modal Eliminar -->
<div *ngIf="modalEliminar" class="fixed inset-0 grid w-full h-full px-8 bg-opacity-50 bg-primary-black-01 z-999 place-items-center">
    <!--aca-->
    <div class="max-w-[494px] bg-primary-white-01 rounded-2xl px-10 py-8 md:px-16 md:pt-18 md:pb-16 relative text-center">
        <fuse-alert
            *ngIf="showAlertEliminar"
            class="my-2"
            [name]="'alertCrear'"
            [appearance]="'soft'"
            [dismissible]="true"
            [showIcon]="false"
            [type]="alert.type"
            [@shake]="alert.type === 'error'">
            {{ alert.message }}
        </fuse-alert>
        <button
            class="absolute top-3 right-3 md:right-8 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="modalEliminar = false; showAlertEliminar = false">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <h1 class="font-bold text-center title-5">Eliminar</h1>

        <p *ngIf="selection.selected.length === 1" class="my-5 text-black paragraph-2 md:my-8">
            Está seguro de eliminar el folio <span class="paragraph-3">{{ selection.selected[0].id }}</span>
        </p>
        <p *ngIf="selection.selected.length > 1 && selection.selected.length < 10" class="my-5 text-black paragraph-2 md:my-8">
            Está seguro de eliminar el siguiente rango de folios:
            <span *ngFor="let selected of selection.selected; index as i" class="paragraph-3">{{ i === 0 ? ' ' : ' - ' }} {{ selected.id }}</span>
        </p>
        <p *ngIf="selection.selected.length >= 10" class="my-5 text-black paragraph-2 md:my-8">
            Está seguro de eliminar <span class="paragraph-3">{{ selection.selected.length }}</span> folios
        </p>

        <button
            mat-flat-button
            class="flex items-center justify-center w-48 h-10 mx-auto mt-5 btn-md btn-primary"
            [color]="'primary'"
            (click)="ejemploBorrarSeleccionados()">
            <span>Eliminar</span>
            <!-- <mat-progress-spinner *ngIf="loginForm.disabled" [diameter]="24" [mode]="'indeterminate'">
					</mat-progress-spinner> -->
        </button>
    </div>
</div>
